<template>
    <div class="floadContainer">
        <ul class="floadList">
            <li><img src="../assets/微信.png" alt="">
                <div class="subMessage weixin">
                    <img src="../assets/联系微信.png" alt="">
                </div>
            </li>
            <li><img src="../assets/电话联系.png" alt="">
                <div class="subMessage phone"><p><strong>TEL：13618609409</strong></p></div>
            </li>
            <li><img src="../assets/返回顶部.png" alt=""></li>
        </ul>


    </div>


</template>

<style scoped>
ul {
    list-style: none;
}

.floadList {
    width: 82px;
    /* background-color: #b8b7b7; */
    border-radius: 5px;
    /* border: 1px solid red; */
}

.floadList li {
    width: 82px;
    height: 82px;
    /* border: 1px solid skyblue; */
    background-color: #b8b7b7;
    border-radius: 5px;
    margin-top: 20%;
    position: relative;
}

.floadList li:hover {
    background-color: #3e413f85;
}

.floadList li:hover .subMessage {
    display: block;
}

img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.subMessage {
    display: none;
    position: absolute;
    right: 112px;
    top: -28%;
}

.weixin {
    width: 200px;
    height: 200px;
    padding: 8px;
    border-radius: 5px;
    background-color: #adadad;
    /* border: 1px solid red; */
}

.phone {
    width: 300px;
    height: 100px;
    line-height: 100px;
    border-radius: 5px;
    background-color: #adadad;
    font-size: 30px;
    /* border: 1px solid red; */
}

.weixin::after {
    content: "";
    display: inline-block;
    /* border: 1px solid black; */
    border-top: 28px solid transparent;
    border-bottom: 28px solid transparent;
    border-left: 15px solid #adadad;
    position: absolute;
    bottom: 50%;
}
.phone::after {
    content: "";
    display: inline-block;
    /* border: 1px solid black; */
    border-top: 28px solid transparent;
    border-bottom: 28px solid transparent;
    border-left: 15px solid #adadad;
    position: absolute;
    bottom: 26%;
    right: -15px;

}
</style>